import { ApplicationInsights } from "@microsoft/applicationinsights-web";

export const appInsights: ApplicationInsights = new ApplicationInsights({
  config: {
    connectionString: import.meta.env.VITE_CONNECTION_STRING,
    loggingLevelTelemetry: 2,
    enableRequestHeaderTracking: true,
    enableResponseHeaderTracking: true,
    enableUnhandledPromiseRejectionTracking: true,
    disableFetchTracking: false,
  },
});
appInsights.loadAppInsights();

export abstract class Dictionary {
  public static generate(inputObjects: any[]) {
    let dictionary: any = {};
    inputObjects?.forEach((object: any) => {
      const key = Object.getOwnPropertyNames(object)[0];
      dictionary[key] = object[key];
    });

    return dictionary;
  }
}

const InsightService = {
  logPageView(name?: string, url?: string) {
    appInsights.trackPageView({
      name: name,
      uri: url,
    });
  },

  logEvent(name: string, properties: any[]) {
    if (properties) {
      const dictionary = Dictionary.generate(properties);
      appInsights.trackEvent({ name: name }, dictionary);
    } else appInsights.trackEvent({ name: name });
  },

  logException(error: Error, severityLevel?: number) {
    appInsights.trackException({
      exception: error,
      severityLevel: severityLevel,
    });
  },

  logTrace(message: string, properties?: any[]) {
    if (properties) {
      const dictionary = Dictionary.generate(properties);
      appInsights.trackTrace({ message: message }, dictionary);
    } else appInsights.trackTrace({ message: message });
  },

  startTelemetry(message: string, properties?: { [key: string]: any }) {
    const telemetryInitializer = (envelope: any) => {
      for (const prop in properties) {
        for (const [key, value] of Object.entries(properties[prop])) {
          envelope.data[key] = value;
        }
      }
      envelope.data.message = message;
    };
    appInsights.addTelemetryInitializer(telemetryInitializer);
  },
};

export default InsightService;
